import React from 'react';
import { useNavigate } from 'react-router-dom';

function EmailVerified() {
  const navigate = useNavigate();

  return (
    <div className="email-confirmation-page">
      <div className="email-confirmation-container">
        {/* Header con icona di successo */}
        <div className="email-confirmation-header">
          <div className="email-confirmation-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m9 11 3 3L22 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="email-confirmation-title">Email Verificata con Successo!</h2>
          <p className="email-confirmation-subtitle">Il tuo account venditore è stato attivato</p>
        </div>

        {/* Contenuto principale */}
        <div className="email-confirmation-content">
          <div className="email-confirmation-message">
            <svg className="email-confirmation-message-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>Il tuo account è stato attivato con successo. Puoi ora accedere alla tua area venditore e completare il profilo aziendale.</p>
          </div>

          <button className="email-confirmation-btn" onClick={() => navigate('/account')}>
            <svg className="email-confirmation-btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3h18v18H3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 9h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Vai al tuo account venditore</span>
          </button>
        </div>

        {/* Footer con progresso */}
        <div className="email-confirmation-footer">
          <div className="email-confirmation-steps">
            <div className="email-confirmation-step completed">
              <div className="email-confirmation-step-number">1</div>
              <span>Registrazione</span>
            </div>
            <div className="email-confirmation-step-arrow">→</div>
            <div className="email-confirmation-step completed">
              <div className="email-confirmation-step-number">2</div>
              <span>Verifica</span>
            </div>
            <div className="email-confirmation-step-arrow">→</div>
            <div className="email-confirmation-step active">
              <div className="email-confirmation-step-number">3</div>
              <span>Completa il Profilo Aziendale</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerified;
